import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Footer from "../../../components/shared/Footer";
import * as APIModels from "../../../models";
import { SubmissionService } from "../../../services/SubmissionService";

import Details from "./components/Details";
import Documents from "./components/Documents";
import CaseData from "./components/CaseData";
import Submission from "./components/Submission";
import Email from "./components/Email";
import Fees from "./components/Fees";
import Party from "./components/Party";

import EmailReceipt from "./components/EmailReceipt";

import Dummy from "./components/dummy";
import TylerPleadings from "../../queue/components/TylerPleadings";

export default function SubmissionReport() {
    const { id } = useParams<{ id?: string }>();
    const [submission, setSubmission] = useState(new APIModels.Submission());

    useEffect(() => {
        SubmissionService.get({ id: id ?? "" }).then(
            (resp) => {
                if (resp.successful === true) {
                    setSubmission(resp.data!);
                    console.log(resp.data?.documents ?? []);
                } else {
                    console.log(resp.message);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Attorneys</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Submission
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Details
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6 col-xl-6">
                        <Details submission={submission} />
                    </div>
                    <div className="col-lg-6 col-xl-6">
                        <Submission submission={submission} />
                    </div>
                    <div className="col-lg-6 col-xl-6">
                        <CaseData submission={submission} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xl-12">
                        <Documents submission={submission} />
                    </div>
                    <div className="col-lg-12 col-xl-12">
                        <Email submission={submission} />
                    </div>
                    <div>
                        <EmailReceipt submission={submission} />
                    </div>
                    <div className="col-lg-12 col-xl-12">
                        <Fees submission={submission} />
                    </div>
                    <div className="col-lg-12 col-xl-12">
                        <Party submission={submission} />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
